/* eslint-disable react/prop-types */
import { Col, Form, Input, Row, Spin, Modal, Switch, DatePicker } from "antd"
import { useEffect, useState } from "react"
import dayjs from "dayjs"
import Notice from "src/components/Notice"
import { getRegexEmail, getRegexMobile } from "src/lib/stringsUtils"
import PropTypes from "prop-types"
import AccountService from "src/services/AccountService"

const ModalUpdateOrganization = ({
  openInsert,
  onCancel,
  onOk,
  getList,
  initialData,
}) => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const memberType = initialData?.MemberType

  useEffect(() => {
    if (openInsert && initialData) {
      const commonValues = {
        PhoneNumber: initialData.PhoneNumber,
        Email: initialData.Email,
        Status: initialData.Status,
      }

      if (memberType == "1") {
        form.setFieldsValue({
          ...commonValues,
          FullName: initialData.FullName,
          DateOfBirth: initialData.DateOfBirth
            ? dayjs(initialData.DateOfBirth)
            : null,
          Identification: initialData.Identification,
          Occupation: initialData.Occupation,
          ResidenceAddress: initialData.ResidenceAddress,
        })
      } else {
        form.setFieldsValue({
          ...commonValues,
          OrganizationName: initialData.OrganizationName,
          RepresentativeName: initialData.RepresentativeName,
          TaxCode: initialData.TaxCode,
          TaxIssuedDate: initialData.TaxIssuedDate
            ? dayjs(initialData.TaxIssuedDate)
            : null,
          Description: initialData.Description,
          Address: initialData.Address,
        })
      }
    }
  }, [openInsert, initialData, form, memberType])

  const handleSubmit = async () => {
    try {
      form.validateFields()
      const values = form.getFieldsValue()
      setLoading(true)

      const payload = {
        ...initialData,
        PhoneNumber: values.PhoneNumber,
        Email: values.Email,
        Status: values.Status ? 1 : 0,
      }

      if (memberType == "1") {
        Object.assign(payload, {
          FullName: values.FullName,
          DateOfBirth: values.DateOfBirth?.format("YYYY-MM-DD"),
          Identification: values.Identification,
          Occupation: values.Occupation,
          ResidenceAddress: values.ResidenceAddress,
        })
      } else {
        Object.assign(payload, {
          OrganizationName: values.OrganizationName,
          RepresentativeName: values.RepresentativeName,
          TaxCode: values.TaxCode,
          TaxIssuedDate: values.TaxIssuedDate?.format("YYYY-MM-DD"),
          Description: values.Description,
          Address: values.Address,
        })
      }

      const res = await AccountService.updateMember(payload)
      if (res?.isOk) {
        Notice({ msg: "Cập nhật thành công." })
        onOk()
        onCancel()
      }
    } catch (error) {
      console.log("error>>handleSubmit:", error)
    } finally {
      setLoading(false)
      getList()
    }
  }

  return (
    <Modal
      title="Cập nhật thông tin hội viên"
      open={openInsert}
      onCancel={onCancel}
      onOk={handleSubmit}
      confirmLoading={loading}
      width={700}
    >
      <Spin spinning={loading}>
        <Form form={form} layout="vertical">
          <Row gutter={16}>
            {memberType == "1" ? (
              <>
                <Col span={24}>
                  <Form.Item
                    label="Họ và tên"
                    name="FullName"
                    rules={[
                      {
                        required: true,
                        message: "Họ và tên không được để trống",
                      },
                    ]}
                  >
                    <Input placeholder="Nhập họ và tên" />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item label="Ngày sinh" name="DateOfBirth">
                    <DatePicker
                      style={{ width: "100%" }}
                      format="DD/MM/YYYY"
                      placeholder="Chọn ngày sinh"
                    />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item label="CMND/CCCD" name="Identification">
                    <Input placeholder="Nhập số CMND/CCCD" />
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Form.Item label="Nghề nghiệp" name="Occupation">
                    <Input placeholder="Nhập nghề nghiệp" />
                  </Form.Item>
                </Col>
              </>
            ) : (
              <>
                <Col span={24}>
                  <Form.Item
                    label="Tên tổ chức"
                    name="OrganizationName"
                    rules={[
                      {
                        required: true,
                        message: "Tên tổ chức không được để trống",
                      },
                    ]}
                  >
                    <Input placeholder="Nhập tên tổ chức" />
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Form.Item label="Người đại diện" name="RepresentativeName">
                    <Input placeholder="Nhập tên người đại diện" />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item label="Mã số thuế" name="TaxCode">
                    <Input placeholder="Nhập mã số thuế" />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item label="Ngày cấp MST" name="TaxIssuedDate">
                    <DatePicker
                      style={{ width: "100%" }}
                      format="DD/MM/YYYY"
                      placeholder="Chọn ngày cấp"
                    />
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Form.Item label="Mô tả" name="Description">
                    <Input.TextArea placeholder="Mô tả tổ chức" rows={3} />
                  </Form.Item>
                </Col>
              </>
            )}

            <Col span={12}>
              <Form.Item
                label="Số điện thoại"
                name="PhoneNumber"
                rules={[
                  {
                    pattern: getRegexMobile(),
                    message: "Số điện thoại từ 8-15 chữ số",
                  },
                ]}
              >
                <Input placeholder="Nhập số điện thoại" />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label="Email"
                name="Email"
                rules={[
                  { pattern: getRegexEmail(), message: "Email sai định dạng" },
                ]}
              >
                <Input placeholder="Nhập email" />
              </Form.Item>
            </Col>

            {memberType == "1" ? (
              <Col span={24}>
                <Form.Item label="Địa chỉ" name="ResidenceAddress">
                  <Input placeholder="Nhập địa chỉ" />
                </Form.Item>
              </Col>
            ) : (
              <Col span={24}>
                <Form.Item label="Địa chỉ" name="Address">
                  <Input placeholder="Nhập địa chỉ" />
                </Form.Item>
              </Col>
            )}

            <Col span={24}>
              <Form.Item
                label="Trạng thái"
                name="Status"
                valuePropName="checked"
              >
                <Switch
                  checkedChildren="Kích hoạt"
                  unCheckedChildren="Vô hiệu"
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Spin>
    </Modal>
  )
}

ModalUpdateOrganization.propTypes = {
  openInsert: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onOk: PropTypes.func.isRequired,
  getList: PropTypes.func.isRequired,
  initialData: PropTypes.object.isRequired,
}

export default ModalUpdateOrganization
